import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fields"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Card from 'components/Card';
import Button from 'components/Button';
import Text from 'components/Text';
import Status from 'components/Status';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import { NewLinkEditorModal } from 'screens/ContentEditorModals';
import { useAiSuggestions } from 'screens/AssetEditor/useAiSuggestions';
import useForm from 'hooks/useForm';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { useCreateDraftAsset } from 'actions/assets';
import { CONTENT_TYPES } from 'utils/asset/constants';
import { addhttps } from 'utils/utils';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import getUserId from 'utils/session/getUserId';
function NewLinkModal(_ref) {
  var parentPlaylist = _ref.parentPlaylist,
    closeNewLinkModal = _ref.onClose,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAiSuggestions = useAiSuggestions(),
    aiSuggestions = _useAiSuggestions.aiSuggestions,
    analyseResource = _useAiSuggestions.analyseResource;
  var inputRef = useRef(null);
  var _useModalQueryParam = useModalQueryParam('add-web-link-details'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasWeblinkDetailsDialog = _useModalQueryParam2[0],
    toggleWeblinkDetailsDialog = _useModalQueryParam2[1];
  var closeModals = function closeModals() {
    toggleWeblinkDetailsDialog();
    closeNewLinkModal();
  };
  var _useForm = useForm({
      fields: {
        link: {
          getDefaultValue: function getDefaultValue() {
            return '';
          },
          required: true
        }
      }
    }),
    fields = _useForm.fields,
    form = _objectWithoutProperties(_useForm, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInvalidUrl = _useState2[0],
    setIsInvalidUrl = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    content = _useState4[0],
    setContent = _useState4[1];
  var emptyUrlAlert = fields.link.wasChanged ? fields.link.error : undefined;
  var invalidUrlAlert = isInvalidUrl ? t('error_invalid_url') : undefined;
  var urlAlert = emptyUrlAlert || invalidUrlAlert;
  var titleId = 'add-link-modal-title';
  var _useCreateDraftAsset = useCreateDraftAsset({
      parentPlaylistId: parentPlaylist.id
    }),
    isCreating = _useCreateDraftAsset.isLoading,
    createDraftAsset = _useCreateDraftAsset.createDraftAsset;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var url, _inputRef$current, ownerId, draftWebAsset, _draftWebAsset$, id, name, description, webUrl, customType, openInIframe, parentId, owner;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            url = addhttps(fields.link.value.trim());
            _context.prev = 2;
            url = new URL(url);
            _context.next = 11;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](2);
            setIsInvalidUrl(true);
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
            return _context.abrupt("return");
          case 11:
            _context.prev = 11;
            // Analyse the resource to get AI suggestions
            analyseResource(url);
            // If author has correct privileges, set them as default owner of the asset during initial link check step
            // Owner can be edited in next step in Details modal
            ownerId = hasPrivilege(ASSET_WRITE) ? getUserId() : null;
            _context.next = 16;
            return createDraftAsset({
              type: CONTENT_TYPES.WEBLINK,
              webUrl: url.href,
              ownerTeamId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.ownerTeamId,
              openInIframe: !!url.href.startsWith('https://'),
              ownerId: ownerId
            });
          case 16:
            draftWebAsset = _context.sent;
            _draftWebAsset$ = draftWebAsset[0], id = _draftWebAsset$.id, name = _draftWebAsset$.name, description = _draftWebAsset$.description, webUrl = _draftWebAsset$.webUrl, customType = _draftWebAsset$.customType, openInIframe = _draftWebAsset$.openInIframe, parentId = _draftWebAsset$.parentId, owner = _draftWebAsset$.owner;
            setContent({
              id: id,
              name: name,
              description: description,
              type: CONTENT_TYPES.WEBLINK,
              webUrl: webUrl,
              customType: customType,
              openInIframe: openInIframe,
              parentId: parentId,
              owner: owner
            });
            toggleWeblinkDetailsDialog(true);
            _context.next = 25;
            break;
          case 22:
            _context.prev = 22;
            _context.t1 = _context["catch"](11);
            if (inputRef.current) {
              inputRef.current.focus();
            }
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 6], [11, 22]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    id: "add-link-modal",
    "aria-label": t('actions_add_new_web_link'),
    onRequestClose: closeNewLinkModal
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    as: "form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('actions_add_web_link'),
    titleId: titleId,
    onClose: closeNewLinkModal
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: t('content_type_url'),
    alert: urlAlert
  }, /*#__PURE__*/React.createElement(TextInput, {
    "data-autofocus": true,
    placeholder: t('links_placeholder'),
    ref: inputRef,
    value: fields.link.value,
    type: "url",
    onChange: function onChange(e) {
      fields.link.set(e.target.value);
      // Reset the custom validation
      e.target.setCustomValidity('');

      // Set invalid URL to false when the user starts typing
      setIsInvalidUrl(false);
    },
    onInvalid: function onInvalid(e) {
      /**
       * Set custom validity for the input field
       */
      var listFormat = new Intl.ListFormat(getUsersISOLocale(), {
        style: 'short',
        type: 'disjunction'
      });
      var protocols = listFormat.format(['https://', 'http://']);
      if (e.target instanceof HTMLInputElement) {
        e.target.setCustomValidity(e.target.value.includes('://') ? '' : t('validate_start_with', {
          value: protocols
        }));
      }
    }
  }))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    iconRight: "arrow-right",
    isDisabled: form.hasErrors || Boolean(urlAlert),
    isLoading: isCreating
  }, t('actions_next')), /*#__PURE__*/React.createElement(Status, {
    role: "status",
    mt: isCreating ? 'xs' : ''
  }, isCreating && /*#__PURE__*/React.createElement(Text, {
    size: "s"
  }, t('modal_add_web_link_check_info'))))), hasWeblinkDetailsDialog && content && /*#__PURE__*/React.createElement(NewLinkEditorModal, {
    inContentManagerContext: inContentManagerContext,
    content: content,
    onClose: closeModals,
    aiSuggestions: aiSuggestions,
    parentPlaylist: parentPlaylist,
    onSubmit: onSubmit
  }));
}
export default NewLinkModal;